export const noImageAvailableHref =
  'https://s3.amazonaws.com/assets.pairin.com/images/no-image-available.png';
